module.exports = __webpack_public_path__ + "img/8_28.f61eee72.png";